<template>
    <div>

        <v-container class="pt-16">
            <h2>¿Cómo elimino mi cuenta de Kefuri?</h2>
            <p>Si deseas eliminar tu cuenta de Kefuri, puedes hacerlo directamente desde la aplicación</p>
            <p>Sigue las instrucciones que apareceran a continuación</p>
            <p>Cualquier duda que tengas, nos puedes mandar un correo a contacto@kefuri.cl</p>

            <v-row class="pt-10">

                <v-col >
                    <v-card class="text-center card-team">
                        <v-card-title class="d-block">
                            Dentro de Kefuri dirígete a tu perfil y presiona editar
                        </v-card-title>

                        <v-img src="../assets/tutorial/delete/delete_1.jpg" contain height="50vh">
                        </v-img>
                    </v-card>
                </v-col>
                <v-col >
                    <v-card class="text-center card-team">
                        <v-card-title class="d-block">
                            Con tu perfil en modo "editar" desliza hasta abajo
                        </v-card-title>

                        <v-img src="../assets/tutorial/delete/delete_2.jpg" contain height="50vh">
                        </v-img>
                    </v-card>
                </v-col>
                <v-col>
                    <v-card class="text-center card-team">
                        <v-card-title class="d-block">
                            En la parte final podrás seleccionar eliminar tu cuenta, la cual se eliminará luego de entre 30
                            y 90 días
                        </v-card-title>

                        <v-img src="../assets/tutorial/delete/delete_3.jpg" contain height="50vh">
                        </v-img>
                    </v-card>
                </v-col>
                <v-col >
                    <v-card class="text-center card-team">
                        <v-card-title class="d-block">
                            Si seleccionas eliminar tu cuenta, se verá un mensaje para confirmar tu decisión
                        </v-card-title>

                        <v-img src="../assets/tutorial/delete/delete_4.jpg" contain height="50vh">
                        </v-img>
                    </v-card>

                </v-col>

            </v-row>

            


        </v-container>
    </div>
</template>

<script>
export default {
    name: 'HowToDelete',
    components: {
    },

    data() {
        return {
            items: [
                { text: 'Hospital Del Salvador', fecha: 'Mayo 2019', src: require('../assets/support/salvador.png'), url: 'https://www.hsalvador.cl/' },
                { text: 'Hospital Dr. Luis Tisné', fecha: 'Diciembre 2020', src: require('../assets/support/hso.gif'), url: 'https://www.hsoriente.cl/' },
                { text: 'Hospital Dr. Gustavo Fricke', fecha: 'Diciembre 2021', src: require('../assets/support/fricke.png'), url: 'http://www.hospitalfricke.cl/' },
                { text: 'Hospital San Camilo', fecha: 'Marzo 2022', src: require('../assets/support/sancamilo.png'), url: 'https://hospitalsancamilo.cl/' },
                { text: 'Complejo Hospitalario San José', fecha: 'Abril 2022', src: require('../assets/support/sanjose.png'), url: 'https://complejohospitalariosanjose.cl/' },
                { text: 'Hospital San Pablo', fecha: 'Agosto 2022', src: require('../assets/support/sanpablo.jpg'), url: 'https://www.hospitalcoquimbo.cl/' },
            ],

            financiamiento: [
                { text: 'CORFO', src: require('../assets/support/corfo.png'), url: 'https://www.corfo.cl//' },
                { text: 'Laboratorio Pfizer', src: require('../assets/support/pfizer.png'), url: 'https://www.pfizer.cl/' },
                { text: 'Laboratorio Novartis', src: require('../assets/support/novartis.png'), url: 'https://www.novartis.com/' },
                { text: 'ANID', src: require('../assets/support/anid.png'), url: 'https://www.anid.cl/' },
                { text: 'Laboratorio Chile-Teva', src: require('../assets/support/labchile-teva.png'), url: 'https://www.laboratoriochile.cl/' },
            ],
        }
    },



}
</script>

<style scoped lang="sass">

    .card-team 
        min-height: 290px

    .display-type
        display: contents

</style>